module.exports = __webpack_public_path__ + "static/img/2.e41af14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/2.png
// module id = JWYK
// module chunks = 0